import type { Translatable } from "app/pages/sales-intelligence/types";
import type { ComponentType, HTMLProps } from "react";
import translateNested from "./translateNested";

type TProps = {
    translatable: Readonly<Translatable>;
    element?: string | ComponentType;
} & HTMLProps<HTMLSpanElement>;

function I18n(props: TProps) {
    const { translatable, element: Element = "span", ...restProps } = props;

    const showDangerousHTML = typeof restProps.dangerouslySetInnerHTML !== "undefined";

    return (
        // @ts-expect-error
        <Element
            {...restProps}
            data-automation-i18n-key={translatable.key}
        >
            {showDangerousHTML ? null : translateNested(translatable)}
        </Element>
    );
}

export default I18n;
